import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface MeasureComponentConfigModel extends ComponentBaseConfigModel {
  titleMeasureArea?: string;
}
